<template>
  <div class="min-h-screen p-4 md:p-6 lg:p-8">
    <Banner />
    <div class="max-w-7xl mx-auto">
      <!-- Header Cards for View Switching (only for Admins) -->
      <div
        v-if="userRole === 'admin'"
        class="mb-8"
      >
        <div class="mb-6 hidden sm:block">
          <h1 class="text-3xl font-bold text-slate-900 mb-2">
            Manage Leaves Here
          </h1>
          <p class="text-slate-600">
            Switch between applying for leaves and managing leave requests
          </p>
        </div>

        <div class="grid grid-cols-2 gap-4 sm:gap-6">
          <LeaveCard
            title="Manage Requests"
            description="Review and approve/decline leave requests from team members"
            :icon="Settings"
            :isActive="currentView === 'management'"
            @select="currentView = 'management'"
          />
          <LeaveCard
            title="Apply for Leave"
            description="Submit new leave requests and track your applications"
            :icon="Plus"
            :isActive="currentView === 'application'"
            @select="currentView = 'application'"
          />
        </div>
      </div>

      <!-- Content Area -->
      <LeaveApplication v-if="currentView === 'application'" />
      <LeaveManagement v-else-if="currentView === 'management'" />
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  import { Plus, Settings } from "lucide-vue-next";
  import LeaveCard from "@/components/LeaveRequest/LeaveCard.vue";
  import LeaveApplication from "@/components/LeaveRequest/ApplyLeave.vue";
  import LeaveManagement from "@/components/LeaveRequest/RequestCards.vue";
  import Banner from "@/components/Banner/TeacherBanner.vue";

  const store = useStore();
  const userRole = computed(() => store.getters.getUserRole);
  const currentView = ref("management");

  // If not admin, force the view to application
  onMounted(() => {
    if (userRole.value !== "admin") {
      currentView.value = "application";
    }
  });
</script>
